import {
  VIDEO_QUALITY_PRESETS,
  type VideoQualityId,
} from './videoQuality'
import styles from './VideoViewport.module.css'

interface Props {
  value: VideoQualityId
  disabled?: boolean
  onChange: (id: VideoQualityId) => void
}

export function VideoQualityControls({ value, disabled, onChange }: Props) {
  return (
    <div
      className={styles.qualitySeg}
      role="group"
      aria-label="Качество видео"
      onPointerDown={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      {VIDEO_QUALITY_PRESETS.map((p) => {
        const active = p.id === value
        return (
          <button
            key={p.id}
            type="button"
            className={active ? styles.qualityBtnActive : styles.qualityBtn}
            title={p.title}
            aria-pressed={active}
            disabled={disabled}
            onClick={() => {
              if (!active) onChange(p.id)
            }}
          >
            {p.label}
          </button>
        )
      })}
    </div>
  )
}
